import { lazy } from 'react';

const SettingsPromptsPage = lazy(() =>
  import('./prompts/page.js').then((module) => ({ default: module.SettingsPromptsPage })),
);

export { SettingsPromptsPage };
